import React from 'react';
import { AlertTriangle, CheckCircle } from 'lucide-react';

const ConfirmModal = ({ title, message, type = 'warning', confirmText, confirmColor, onConfirm, onCancel }) => {
  const isDestructive = type === 'danger' || confirmColor === '#dc3545';
  const buttonColor = confirmColor || (isDestructive ? '#dc3545' : '#4A90E2');
  const buttonHoverColor = isDestructive ? '#c82333' : '#357ABD';
  const buttonText = confirmText || (isDestructive ? 'Delete' : 'Confirm');

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '2rem'
    }} onClick={onCancel}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '2.5rem',
          maxWidth: '500px',
          width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          animation: 'scaleIn 0.2s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '1.5rem'
        }}>
          {isDestructive ? (
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: '#fee',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
              <AlertTriangle size={28} style={{ color: '#dc3545' }} />
            </div>
          ) : (
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: '#fff3cd',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
              <AlertTriangle size={28} style={{ color: '#ffc107' }} />
            </div>
          )}
          <h2 style={{
            fontSize: '1.8rem',
            margin: 0,
            color: '#333'
          }}>
            {title}
          </h2>
        </div>

        <p style={{
          fontSize: '1.1rem',
          color: '#666',
          lineHeight: '1.6',
          marginBottom: '2rem'
        }}>
          {message}
        </p>

        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onCancel}
            style={{
              padding: '0.875rem 1.75rem',
              fontSize: '1rem',
              fontWeight: '600',
              color: '#666',
              backgroundColor: '#f8f9fa',
              border: '2px solid #e9ecef',
              borderRadius: '10px',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef';
              e.target.style.borderColor = '#dee2e6';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.borderColor = '#e9ecef';
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '0.875rem 1.75rem',
              fontSize: '1rem',
              fontWeight: '600',
              color: 'white',
              backgroundColor: buttonColor,
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = buttonHoverColor;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = buttonColor;
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
